export const types = Object.freeze({
  EDITABLE: 'editable',
  READ_ONLY: 'readOnly',
});

export const equipmentSizes = [
  '20FtContainer',
  '48FtTrailer',
  '40FtStandardContainer',
  '53FtTrailer',
  '40FtHighCubeContainer',
  'StraightTruck',
  '45FtContainer',
  'OtherContainer',
];
